const VALID_STATUSES = ['not-started', 'in-progress', 'blocked', 'wrapping-up']

function isValidStatus(value) {
  return VALID_STATUSES.includes(value)
}

function generateId() {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return `p_${crypto.randomUUID().slice(0, 8)}`
  }
  return `p_${Math.random().toString(36).slice(2, 10)}`
}

export function migratePrioritiesData(raw) {
  if (!raw || typeof raw !== 'object') {
    return { items: [] }
  }

  const rawItems = Array.isArray(raw.items) ? raw.items : []

  const migrated = rawItems
    .map((legacy) => {
      // Already in new format (object with text field)
      if (legacy && typeof legacy === 'object' && 'text' in legacy) {
        return {
          id: legacy.id || generateId(),
          text: typeof legacy.text === 'string' ? legacy.text : '',
          status: isValidStatus(legacy.status) ? legacy.status : null,
          goalId: typeof legacy.goalId === 'string' ? legacy.goalId : null,
        }
      }

      // Legacy format: plain string
      if (typeof legacy === 'string') {
        return {
          id: generateId(),
          text: legacy,
          status: null,
          goalId: null,
        }
      }

      // Legacy format: object with some other shape
      if (legacy && typeof legacy === 'object') {
        return {
          id: legacy.id || generateId(),
          text: typeof legacy.value === 'string'
            ? legacy.value
            : typeof legacy.name === 'string'
              ? legacy.name
              : '',
          status: isValidStatus(legacy.status) ? legacy.status : null,
          goalId: typeof legacy.goalId === 'string' ? legacy.goalId : null,
        }
      }

      // Unrecognized — skip
      return null
    })
    .filter(Boolean)
    .slice(0, 3)

  return { items: migrated }
}
